module.exports = __webpack_public_path__ + "static/media/refresh_white_24dp.3f387bfe.svg";